import { useEffect, useState } from 'react';

import type { PricingPageShopProduct_magento2_products_items_Magento2_ConfigurableProduct_variants as Variant } from './__generated__/PricingPageShopProduct';

const useProductVariant = (
  variants: (Variant | null)[] | null,
  preselectedSKU?: string | null,
) => {
  const [selectedVariant, setSelectedVariant] = useState<Variant | null>(null);

  useEffect(() => {
    const preselectedVariant =
      variants?.find((v) => v?.product?.sku === preselectedSKU) ?? null;
    const defaultVariant = variants?.find(
      (variant) => variant?.product?.isDefaultWithinAllVariants,
    );
    const firstVariant = variants?.[0];

    if (preselectedSKU && preselectedVariant) {
      setSelectedVariant(preselectedVariant);
    } else if (defaultVariant) {
      setSelectedVariant(defaultVariant);
    } else if (firstVariant) {
      setSelectedVariant(firstVariant);
    }
  }, [preselectedSKU, variants]);

  return {
    selectedVariant,
    setSelectedVariant,
  };
};

export default useProductVariant;
